'use client'

import { JSX } from 'react'

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'

export { CollapsibleTrigger } from '~/components/component-library/Collapsible/components/CollapsibleTrigger'
export { CollapsibleContent } from '~/components/component-library/Collapsible/components/CollapsibleContent'

export const Collapsible = ({
  children,
  defaultOpen = false,
  open,
  onOpenChange,
  className,
}: {
  children: JSX.Element[]
  defaultOpen?: boolean
  /** Controlled open state — pair with onOpenChange. */
  open?: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
}) => (
  <CollapsiblePrimitive.Root
    defaultOpen={defaultOpen}
    open={open}
    onOpenChange={onOpenChange}
    className={className}
  >
    {children}
  </CollapsiblePrimitive.Root>
)
